// extracted by css-extract-rspack-plugin
export default {"cls1":"AuthorPopover-cls1_xYx","cls2":"AuthorPopover-cls2_k-f AuthorPopover-cls1_xYx"};